import {
   clsx
  ,styled
  ,Box
  ,Paper
} from 'external/material'

import SectionLink from './SectionLink'
import useTranslations from 'hooks/translations'

const SectionLinksContainer = styled(Paper)(sectionStyles)
 
export default function Sections ({sections}) {

  const {translate} = useTranslations()
  const createSection = (section, index) => (<SectionLink {...{key: section.id, index, section, sections}} />)

  return (
    <SectionLinksContainer className="root">
      <Box className="header">
        {translate('questions')}
      </Box>
      <Box className="sections">
        {sections.map(createSection)}
      </Box>
    </SectionLinksContainer>
  )  
}


function sectionStyles (theme) {
  return {
    "&.root": {
      flexGrow: 1,
      overflowY: 'hidden',
      display: 'flex',
      flexDirection: 'column'
    },
    "& .header": {
      padding: 10,
      color: '#555764',
      fontSize: '12pt'
    },
    "& .sections": {
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
    }
  }
}
